import {
  Menu,
  MenuItem,
  FormControlLabel,
  Divider,
  Grid2,
  IconButton,
  Tooltip,
  Checkbox,
  Collapse
} from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { ExpandMore, FilterAltOff } from "@mui/icons-material";
import { useLoading } from "../../../../components/Loading";
import { useEffect, useState } from "react";
import { useSnackbar } from "../../../../context/popup";
import { fetchData } from "../../../../services";
import DropDownConfig from "../../../Utils/DropDownConfig";


const WorkflowStepDependencyFilterDialog = ({ anchorEl, open, onClose, filterData, setFilterData, onApply }) => {

    const {setCircleLoading} = useLoading();
    const {showSnackbar} = useSnackbar();

    //accordian states
    const [openActive, setOpenActive] = useState(false);
    const [openStep, setOpenStep] = useState(false);
    const [openState, setOpenState] = useState(false);
    const [openDependencyType, setOpenDependencyType] = useState(false);

    //options states
    const [stepOptions, setStepOptions] = useState([]);
    const [dependencyTypeOptions, setDependencyTypeOptions] = useState([]);
    
    const sectionHeader = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "2px 6px",
        background: "#e9ecf5",
        borderRadius: "6px",
        cursor: "pointer",
        mb: 0.5,
    };

    const menuItemStyle = {
        borderRadius: "6px",
        my: 0.2,
        mx: 0.5,
        py: 0.3,
        "&:hover": { backgroundColor: "#dfe6ff" },
    };

    const labelStyle = {
        m: 0,
        "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
    };

    useEffect(() => {
        if(!open){
            return;
        }
        fetchWorkflowStepList();
    },[open]);

    const fetchWorkflowStepList = async () => {
        setCircleLoading(true);
        try {
        const response = await fetchData(`/reference/orchestration/work-flow-steps?dropdown=true`)        
        if(response?.success){
            setStepOptions(response?.data?.items.map((item)=>({
                value: item?.id,
                label: item?.stepName
            })))   
        }
        else{
            //throw error
            showSnackbar("Error Fetching Workflow List", "error")
        }
        } catch (error) {
            console.error('Error Fetching Api List:', error);
            showSnackbar(error?.message, "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchDependencyList = async () => {
        setCircleLoading(true);
        try {
        const response = await fetchData(`/orchestration/key-value-store?dropdown=true&code=${DropDownConfig?.operationWorkflowDependencyType}`)
        if(response?.success){
            const formattedResponse = response?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName,
            })) || [];
            setDependencyTypeOptions(formattedResponse);
        }
        }catch(error){
            console.error("Error Fetching Data",error);
            showSnackbar("Error Fetching Data","error");
        }finally{
            setCircleLoading(false);
        }
    };

    const handleChange = ({ target: { name, value } }) => {
        setFilterData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const onClearFilters = () => {
        setFilterData({
            isActive: "",
            stepId: "",
            dependsOnStepId: "",
            dependencyType: ""
        });
    };


  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{backgroundColor: "rgba(0, 0, 0, 0.3)",}}
      PaperProps={{
          elevation: 3,
          sx: {
            width: 260,
            padding: 1.5,
          },
      }}
    >
        <MaterialBox
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",             
        }}
        >
            {/* Title */}
            <MaterialTypography variant="body2" fontWeight="bold">
                Step Dependency Filter
            </MaterialTypography>

            {/* Clear Button */}
            <Tooltip title="Clear Filter" disableInteractive>
                <IconButton
                    size="small"
                    onClick={onClearFilters}
                    sx={{ color: "#ce0707ff" }}
                >
                    <FilterAltOff />
                </IconButton>
            </Tooltip>
        </MaterialBox>


      {/* Content */}
        <MaterialBox ml={1} mt={1} sx={{
        maxHeight: 300, 
        overflowY: "auto"}}>
            <Grid2 container>
                {/* Active */}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => setOpenActive(!openActive)}>
                        <MaterialTypography variant="body3" fontWeight="bold">
                            Active Status
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openActive ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openActive}>
                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: true },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === true} />}
                            label="Active"
                            sx={labelStyle}
                            />
                        </MenuItem>

                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: false },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === false} />}
                            label="Inactive"
                            sx={labelStyle}
                            />
                        </MenuItem>
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Step*/}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            setOpenStep(!openStep);
                        }}
                        >
                        <MaterialTypography variant="body3" fontWeight="bold">
                            Workflow Step
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openStep ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openStep}>
                        {stepOptions?.map((country) => (
                            <MenuItem
                            key={country.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "stepId", value: country.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.stepId === country.value} />}
                                label={country.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Depends On Step*/}
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openState;
                            setOpenState(nextState);
                        }}                        
                            >
                            <MaterialTypography variant="body3" fontWeight="bold">
                            Depends On Step
                            </MaterialTypography>

                            <IconButton size="small">
                            <ExpandMore
                                sx={{
                                transform: openState ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                                }}
                            />
                            </IconButton>
                        </MaterialBox>

                        <Collapse in={openState}>
                            {stepOptions?.map((state) => (
                            <MenuItem
                                key={state.value}
                                disableRipple
                                sx={menuItemStyle}
                                onClick={() =>
                                handleChange({
                                    target: { name: "dependsOnStepId", value: state.value },
                                })
                                }
                            >
                                <FormControlLabel
                                control={
                                    <Checkbox
                                    size="small"
                                    checked={filterData.dependsOnStepId === state.value}
                                    />
                                }
                                label={state.label}
                                sx={labelStyle}
                                />
                            </MenuItem>
                            ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Dependency Type */}
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openDependencyType;
                            setOpenDependencyType(nextState);

                            if (nextState && dependencyTypeOptions.length === 0) {
                                fetchDependencyList();
                            }
                        }}>
                            <MaterialTypography variant="body3" fontWeight="bold">
                                Dependency Type
                            </MaterialTypography>

                            <IconButton size="small">
                                <ExpandMore
                                sx={{
                                    transform: openDependencyType ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "0.2s",
                                }}
                                />
                            </IconButton>
                        </MaterialBox>

                        <Collapse in={openDependencyType}>
                        {dependencyTypeOptions?.map((district) => (
                            <MenuItem
                            key={district.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "dependencyType", value: district.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={
                                <Checkbox
                                    size="small"
                                    checked={filterData.dependencyType === district.value}
                                />
                                }
                                label={district.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
            </Grid2>
        </MaterialBox>

        <Divider />

        {/* Apply button */}
        <MenuItem
        onClick={() => onApply()}
        disableRipple
        sx={{
            padding: "6px 16px", 
            width: "fit-content",
            minWidth: "0px",
            mx: "auto",  
            borderRadius: "6px",
            backgroundColor: "#bcc7e9",
            color: "white",
            display: "flex",
            justifyContent: "center",
            transition: "0.2s ease",

            "&:hover": {
            backgroundColor: "#93a6e8",
            }
        }}
        >
        <MaterialTypography variant="button" fontWeight="bold">
            APPLY FILTER
        </MaterialTypography>
        </MenuItem>
    </Menu>
  );
};

export default WorkflowStepDependencyFilterDialog;
